module.exports = __webpack_public_path__ + "img/placeholder.38c72223.jpg";